import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { SharedModule } from '@shared/shared.module'

export interface LibraryCascadeChangesModalConfig {
  itemType: string
  description?: string
  onSubmit: (result: boolean) => any
}

@Component({
  standalone: true,
  templateUrl: './library-cascade-changes-modal.component.html',
  styleUrls: ['./library-cascade-changes-modal.component.scss'],
  imports: [SharedModule],
})
export class LibraryCascadeChangesModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LibraryCascadeChangesModalConfig,
    public dialogRef: MatDialogRef<LibraryCascadeChangesModalComponent>
  ) {}

  close = (value: boolean) => (this.data.onSubmit?.(value), this.dialogRef.close(value))
}
